/*--------------------------------------------*\
    Include Globally Useful JS Functions
\*--------------------------------------------*/

ThemeJS.Functions = (function ( $, root ) {


    function send_ajax_request ( args ) {
        args.data.nonce = ThemeJS.Variables.Ajax.nonce;
        $.post( ThemeJS.Variables.Ajax.url, args.data, function ( response ) {
            response = JSON.parse( response );
            if ( !response.hasOwnProperty( 'data' ) ) { response.data = {}; }
            if ( response.success && typeof args.success == 'function' ) {
                args.success( response.data );
            } else if ( !response.success && typeof args.error == 'function' ) {
                args.error( response.data );
            }
        });
    }


    function wp_rest_request ( args ) {
        let ajax_args = {
            method: ( args.method ?? 'GET' ).toString().toUpperCase(),
            url: `${ ThemeJS.Variables.WP_REST.root }${ args.endpoint }`,
            data: args.data,
            contentType: 'application/json; charset=utf-8',
            beforeSend ( xhr ) {
                xhr.setRequestHeader( 'X-WP-Nonce', ThemeJS.Variables.WP_REST.nonce );
            },
            success ( data ) {
                if ( typeof args.success == 'function' ) {
                    args.success( data );
                }
            },
            error ( data ) {
                if ( typeof args.error == 'function' ) {
                    args.error( data );
                }
            },
            complete ( data ) {
                if ( typeof args.complete == 'function' ) {
                    args.complete( data );
                }
            }
        };
        if ( ajax_args.method != 'GET' ) {
            ajax_args.dataType = 'json';
            ajax_args.data = JSON.stringify( ajax_args.data );
        }
        jQuery.ajax( ajax_args );
    }


    function get_query_parameter( name, url ) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&#]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }


    let scrollbar_width = null;
    // taken from https://stackoverflow.com/questions/13382516/getting-scroll-bar-width-using-javascript
    function get_scrollbar_width () {
        if ( scrollbar_width === null ) {
            let outer = document.createElement('div');
            outer.style.visibility = 'hidden';
            outer.style.overflow = 'scroll';
            outer.style.msOverflowStyle = 'scrollbar';
            document.body.appendChild(outer);
            let inner = document.createElement('div');
            outer.appendChild(inner);
            scrollbar_width = ( outer.offsetWidth - inner.offsetWidth );
            outer.parentNode.removeChild(outer);
        }
        return scrollbar_width;
    }


    function get_element_scroll_to_position ( $target ) {
        if ( $target instanceof String || $target instanceof HTMLElement ) {
            $target = $( $target );
        }
        if ( ! $target instanceof jQuery || !$target.length ) {
            return 0;
        }
        return $target.offset().top - $( '#site-header' ).outerHeight() - 30;
    }

    function scroll_to_element ( $target, speed = 500, callback = null ) {
        $('html, body').animate(
            { scrollTop: get_element_scroll_to_position( $target ) },
            speed,
            callback
        );
    }

    function maybe_scroll_up ( $target ) {
        if ( $(window).scrollTop() > ThemeJS.Functions.get_element_scroll_to_position( $target ) ) {
            ThemeJS.Functions.scroll_to_element( $target );
        }
    }

    
    return {
        send_ajax_request,
        wp_rest_request,
        get_query_parameter,
        get_scrollbar_width,
        get_element_scroll_to_position,
        scroll_to_element,
        maybe_scroll_up,
    }

})( jQuery, this );